import React, { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WebStoryFetchData } from "../../redux/actions/webstoryAction";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";

const WebStoryAll = () => {
  const dispatch = useDispatch();
  
  // State for lazy loading
  const [stories, setStories] = useState([]);
  const [start, setStart] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const limit = 15; // Number of stories per fetch

  const webStories = useSelector((state) => state?.WebStoryReducer?.data);
  const [activeTabSam, setActiveTabSam] = useState("All");

  const categories = [{ name: "All" }, ...(webStories.category || [])];

  const listRef = useRef(null);
  const [showArrows, setShowArrows] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (listRef.current) {
        setShowArrows(
          listRef.current.scrollWidth > listRef.current.clientWidth
        );
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, []);

  // Fetch stories with start and append
  const fetchStories = useCallback(async () => {
    if (loading || !hasMore) return;
    setLoading(true);
    await dispatch(
      WebStoryFetchData(
        start,
        limit,
        activeTabSam === "All" ? "" : activeTabSam
      )
    );
    setLoading(false);
  }, [dispatch, start, hasMore, loading, activeTabSam]);

  // On mount and when start or activeTabSam changes, fetch stories
  useEffect(() => {
    fetchStories();
    // eslint-disable-next-line
  }, [start, activeTabSam]);

  // When webStories.data changes, append to stories
  useEffect(() => {
    if (webStories?.data && Array.isArray(webStories.data)) {
      setStories((prev) => {
        if (start === 0) return webStories.data;
        const newStories = webStories.data.filter(
          (story) => !prev.some((s) => s.id === story.id)
        );
        return [...prev, ...newStories];
      });
      if (webStories.data.length < limit && start !== 0) {
        setHasMore(false);
      }
    }
  }, [webStories, start]);

  // Infinite scroll handler
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
          document.documentElement.offsetHeight - 300 &&
        hasMore &&
        !loading
      ) {
        setStart((prev) => prev + limit);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, loading]);

  const { 21: assetbaseUrl, 57: liveYtUrl } = useSelector(
    (state) => state?.SettingReducer?.data
  );

  const [icon, seticon] = useState();

  useEffect(() => {
    const asd = document.getElementById("content-sam-home").scrollWidth;
    seticon(asd);
  }, []);
  // Handle the left and right scroll events
  const leftScroll = useCallback((event) => {
    const conent = document.querySelector("#content-sam-home");
    conent.scrollLeft -= 100;
    event.preventDefault();
  }, []);

  const rightScroll = useCallback((event) => {
    const conent = document.querySelector("#content-sam-home");
    conent.scrollLeft += 100;
    event.preventDefault();
  }, []);

  // Set the active Samagra tab based on the default active tab
  // useEffect(() => {
  //   if (!activeTabSam && defaultActiveSamagraTab?.value) {
  //     setActiveTabSam(defaultActiveSamagraTab?.value);
  //   }
  // }, [defaultActiveSamagraTab?.value, activeTabSam]);

  // Fetch the city result data based on the active Samagra tab
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //   //   if (activeTabSam) {
  //   //     let customLocation = "";
  //   //     if (myLocation) {
  //   //       const parseData = JSON.parse(myLocation);
  //   //       customLocation = "?lat=" + parseData.lat + "&long=" + parseData.long;
  //   //     }
  //   //     dispatch(CityResultFetchData(activeTabSam + customLocation));
  //   //   }
  //   // }, 300);
  //   // return () => {
  //   //   clearTimeout(timer);
  //   // };
  // }, [activeTabSam, myLocation, dispatch]);

  return (
    <>
      <Helmet>
        <title>
          Web Stories in Gujarati | ગુજરાતી વેબ સ્ટોરીઝ | Visual Stories in
          Gujarati
        </title>
        <meta
          property="og:title"
          content="Web Stories in Gujarati | ગુજરાતી વેબ સ્ટોરીઝ | Visual Stories in Gujarati"
        />

        <meta
          name="keywords"
          content="News, Gujarati News, Web Stories, Visual Stories, Gujarat Web Stories, Entertainment Web Stories, India Web Stories, World Web Stories, Sports Web Stories, Cricket Web Stories, Health Web Stories, Fitness Web Stories, Business Web Stories, Tech Web Stories, lifestyle Web Stories, Food Web Stories, Travel Web Stories, Astrology Web Stories, Bhakti Web Stories, Monsoon Web Stories, Fashion Web Stories, Beauty Web Stories, Celebrity Web Stories, Gujarat Visual Stories, Entertainment Visual Stories, India Visual Stories, World Visual Stories, Sports Visual Stories, Cricket Visual Stories, Health Visual Stories, Fitness Visual Stories, Business Visual Stories, Tech Visual Stories, lifestyle Visual Stories, Food Visual Stories, Travel Visual Stories, Astrology Visual Stories, Bhakti Visual Stories, Monsoon Visual Stories, Fashion Visual Stories, Beauty Visual Stories, Celebrity Visual Stories, ગુજરાતી વેબ સ્ટોરી, ગુજરાતી વેબ વાર્તાઓ, Web Stories in Gujarati, Gujarati Web Stories, News Web Stories"
        />

        <meta
          name="description"
          content="Discover the latest Web Stories from Sandesh with breaking Gujarat, India and world news, visuals, trending topics and quick updates optimised for mobile users."
        />

        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <section className="sport trendingheight">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-12 col-xl-12">
              <div className="d-flex align-items-center">
                {showArrows && (
                  <div className="float-left">
                    <button className="buttonGujSamagra" onClick={leftScroll}>
                      <i className="fa fa-angle-left" aria-hidden="true" />
                    </button>
                  </div>
                )}
                <ul
                  className="center asd"
                  id="content-sam-home"
                  ref={listRef}
                  style={{ overflowX: "auto", whiteSpace: "nowrap" }}
                >
                  {categories.map((els, index) => (
                    <li
                      className="nav-item internal cursor-pointer"
                      style={{ width: "auto" }}
                      key={index}
                      onClickCapture={() =>
                         ReactGA.event({
                          category: "Homepage",
                          action: "Webstory",
                          label: els?.name,
                        })
                      }
                    >                      
                      <a
                        className={`nav-link guj-metro-carousel-tabs ${
                          activeTabSam === els?.name
                            ? "active-guj-samagra w-100"
                            : ""
                        }`}
                        data-toggle="tab"
                        onClick={() => {
                          if (activeTabSam !== els?.name) {
                            setActiveTabSam(els?.name);
                            setStart(0);
                            setStories([]);
                            setHasMore(true);

                            ReactGA.send({
                            hitType: "pageview",
                            page: `/webstories/${els?.name}`,
                            title: "Webstory",
                          });

                          }
                        }}
                      >
                        {els?.name}
                      </a>
                    </li>
                  ))}
                </ul>
                {showArrows && (
                  <div className="float-right">
                    <button className="buttonGujSamagra" onClick={rightScroll}>
                      <i className="fa fa-angle-right" aria-hidden="true" />
                    </button>
                  </div>
                )}
              </div>
              <div
                class="story-list"
                style={{ flexWrap: "wrap", marginTop: "15px" }}
              >
                {loading && stories.length === 0 ? (
                  <div>Loading...</div>
                ) : stories && stories.length > 0 ? (
                  stories.map((story) => (
                    <div class="story-card" data-index="0" key={story.id}>
                      <Link
                        to={`/webstory/${story.url}`}
                        state={{ storyId: story.id, fromWebStory: true }}
                        rel="noopener noreferrer"
                        target="_blank"
                        className=""
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <img
                          src={`${
                            assetbaseUrl?.value
                          }${story?.main_image?.replace("", "")}`}
                          alt="Web Story 1"
                        />
                        <h3 class="story-caption">{story.title}</h3>
                      </Link>
                    </div>
                  ))
                ) : (
                  <center
                    style={{
                      width: "100%",
                      textAlign: "center",
                      padding: "20px 0",
                    }}
                  >
                    <h5>No stories found</h5>
                  </center>
                )}
                {loading && stories.length > 0 && <div>Loading more...</div>}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <HomeTaboola key={Math.random()} /> */}
    </>
  );
};

export default WebStoryAll;